import {
    Channel as AppChannel,
    DeliveryTimeType as AppDeliveryTimeType,
    DeliveryTypeCategory as AppDeliveryTypeCategory,
    PaymentType as AppPaymentType,
    Phase as AppPhase,
    State as AppState,
} from '@/features/orders/constants/app'
import { firebaseToAppChannel } from '@/features/orders/constants/conversions/channel'
import {
    appToFirebaseDeliveryTimeType,
    firebaseToAppDeliveryTimeType,
} from '@/features/orders/constants/conversions/deliveryTimeType'
import { firebaseToAppDeliveryTypeCategory } from '@/features/orders/constants/conversions/deliveryTypeCategory'
import { firebaseToAppPaymentType } from '@/features/orders/constants/conversions/paymentType'
import { firebaseToAppPhase } from '@/features/orders/constants/conversions/phase'
import { firebaseToAppState } from '@/features/orders/constants/conversions/state'
import {
    Channel as FirebaseChannel,
    DeliveryTimeType as FirebaseDeliveryTimeType,
    DeliveryTypeCategory as FirebaseDeliveryTypeCategory,
    PaymentType as FirebasePaymentType,
    Phase as FirebasePhase,
    State as FirebaseState,
} from '@/features/orders/constants/firebase'

export const convertDeliveryTimeTypeToApp = (
    deliveryTimeType: FirebaseDeliveryTimeType
): AppDeliveryTimeType =>
    firebaseToAppDeliveryTimeType[deliveryTimeType] ||
    (deliveryTimeType as unknown as AppDeliveryTimeType)

export const convertDeliveryTimeTypeToFirebase = (
    deliveryTimeType: AppDeliveryTimeType
): FirebaseDeliveryTimeType =>
    appToFirebaseDeliveryTimeType[deliveryTimeType] ||
    (deliveryTimeType as unknown as FirebaseDeliveryTimeType)

export const convertDeliveryTypeCategoryToApp = (
    deliveryTypeCategory: FirebaseDeliveryTypeCategory
): AppDeliveryTypeCategory =>
    firebaseToAppDeliveryTypeCategory[deliveryTypeCategory] ||
    (deliveryTypeCategory as unknown as AppDeliveryTypeCategory)

export const convertChannelToApp = (channel: FirebaseChannel): AppChannel =>
    firebaseToAppChannel[channel] || (channel as unknown as AppChannel)

export const convertPhaseToApp = (phase: FirebasePhase): AppPhase =>
    firebaseToAppPhase[phase] || (phase as unknown as AppPhase)

export const convertStateToApp = (state: FirebaseState): AppState =>
    firebaseToAppState[state] || (state as unknown as AppState)

export const convertPaymentTypeToApp = (paymentType: FirebasePaymentType): AppPaymentType =>
    firebaseToAppPaymentType[paymentType] || (paymentType as unknown as AppPaymentType)
